import { Box, Button, Typography } from "@mui/material";
import styels from "../../styles/components/editorFilter.module.scss";
import React, { useEffect, useState } from "react";
import CalenderIcon from "../../public/assets/icons/CalenderIcon";
import FilterIcon from "../../ui/Icons/FilterIcon";
import useCalenderFilter from "../../hooks/useCalenderFilter";
import AlltimemenuTwo from "../../ui/Customdropdown/AlltimemenuTwo";
import CalenderDate from "../../pages/Calender";
import dayjs from "dayjs";

const MyVideosDuplicateFilter = ({
  setCalenderDate,
  setDateFilter,
  currentFilterParams,
  videoCountry,
  setVideoCountry,
  dateFilter,
  handleDateFilter,
  handleFilter,
  filterParams,
  total,
}) => {
  //calender functions
  const calenderId = "calendar-input-home";
  const {
    calenderFilter,
    DateFilterRangeList,
    calenderFilterShowValue,
    changeCalenderFilter,
    calenderOpen,
    resetCalender,
    confirmCalender,
    confirmedCalenderValue,
    calenderValue,
    setCalenderValue,
    toggleCalender,
    closeCalender,
    confirmCalenderTwo,
    dateRangeFilter: {
      dateRangeFilterAnchor,
      openedDateRangeFilter,
      handleOpenDateRangeFilter,
      handleCloseDateRangeFilter,
    },
  } = useCalenderFilter({
    containerId: calenderId,
  });

  useEffect(() => {
    const startDate = dayjs(confirmedCalenderValue?.[0]).format("DD-MM-YYYY");
    const endDate = dayjs(confirmedCalenderValue?.[1]).format("DD-MM-YYYY");
    setCalenderDate({ from: startDate, to: endDate });
  }, [confirmedCalenderValue]);

  // calender Date

  return (
    <Box className={styels.editorFilterWrapper}>
      <Box className={styels.editorFilterWrapperTxt}>
        <Typography variant="body1">
          Showing videos for{" "}
          {calenderFilter?.name?.length ? "" : "the period from"}
        </Typography>
        {/* calender Date */}
        <AlltimemenuTwo
          filterParams={filterParams}
          dateRangeFilterAnchor={dateRangeFilterAnchor}
          DateFilterRangeList={DateFilterRangeList}
          openedDateRangeFilter={openedDateRangeFilter}
          handleCloseDateRangeFilter={handleCloseDateRangeFilter}
          changeCalenderFilter={changeCalenderFilter}
          calenderFilter={calenderFilter}
          handleOpenDateRangeFilter={handleOpenDateRangeFilter}
        />
        <Typography variant="body1" className={styels.dateShow}>
          {/* calender */}
          {filterParams?.filter_active ? (
            "one or more selected filters"
          ) : calenderFilter?.name?.length ? (
            `(${dayjs(confirmedCalenderValue?.[0]).format("LL")} - ${dayjs(
              confirmedCalenderValue?.[1]
            ).format("LL")})`
          ) : (
            <>
              {/* {"the period from "} */}
              {confirmedCalenderValue?.[0] ? (
                <span className="dayList">
                  {dayjs(confirmedCalenderValue?.[0]).format("LL")}
                </span>
              ) : null}
              {" to "}
              {calenderValue?.[1] ? (
                <span className="dayList">
                  {dayjs(confirmedCalenderValue?.[1]).format("LL")}
                </span>
              ) : null}
            </>
          )}
          {/* calender */}
        </Typography>

        {/* calender */}
        {calenderFilter?.name !== "All time" ? (
          <span className="reset_picker" onClick={resetCalender}>
            <svg
              width="11"
              height="11"
              viewBox="0 0 11 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.5 10C7.975 10 10 7.975 10 5.5C10 3.025 7.975 1 5.5 1C3.025 1 1 3.025 1 5.5C1 7.975 3.025 10 5.5 10Z"
                stroke="currentColor"
                strokeLinecap="round"
                stroke-linejoin="round"
              ></path>
              <path
                d="M4.22705 6.7832L6.77263 4.23762"
                stroke="currentColor"
                strokeWidth="0.8"
                strokeLinecap="round"
                stroke-linejoin="round"
              ></path>
              <path
                d="M6.77263 6.76238L4.22705 4.2168"
                stroke="currentColor"
                strokeWidth="0.8"
                strokeLinecap="round"
                stroke-linejoin="round"
              ></path>
            </svg>
            reset
          </span>
        ) : null}

        {/* calender */}
      </Box>

      <Box className={styels.editorFilterButtonGroup}>
        {/* <Button className={styels.metaUpdate}><span>Metadata to update</span></Button> */}

        {/* <Button className={styels.filterButton} onClick={filterSelect} ><FilterIcon/></Button> */}
        {/* calender */}
        <div style={{ marginLeft: "10px" }}>
          <CalenderDate confirmCalender={confirmCalenderTwo} />
        </div>
        <div style={{ marginLeft: "10px" }}>
          <Button
            style={{
              background: "#F0F3FF",
              borderRadius: "8px 8px 0px 8px",
              padding: "7px 10px",
            }}
          >
            All videos:{" "}
            <span style={{ paddingLeft: "5px" }}> {total ? total : "_"}</span>
          </Button>
        </div>
        {/* calender */}
      </Box>
    </Box>
  );
};

export default MyVideosDuplicateFilter;
